import React from "react";

export default () => (
  <div className="px-5">
    <h1 className="display-4">Page Not Found</h1>
    <p>Sorry, this page does not exist</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/views/pages/not-found.js